// https://arbres.iker.cnrs.fr/index.php?title=Genre#divergence_de_genre_lexical_breton.2Ffran.C3.A7ais
import { newAdjQual, newNoun, toLowerCase } from './wordUtils';

export const getDicoUrl = (rawText) => {
  let rawTextLow = rawText.toLowerCase();

  if (!rawTextLow.trim()) {
    return '';
  }

  let firstLetter;
  if (rawTextLow.startsWith('c\'h')) {
    firstLetter = 'c-h';
    rawTextLow = rawTextLow.replaceAll('c\'h', 'ch');

  } else if (rawTextLow.startsWith('ch')) {
    firstLetter = 'ch';

  } else {
    firstLetter = rawTextLow[ 0 ];
  }

  const normalizedText = toLowerCase(rawTextLow);

  return `http://devri.bzh/dictionnaire/${firstLetter}/${normalizedText}/`;
};

export const sectionsForNoun = [
  {
    text: 'Feminine, singular:',
    words: [
      newNoun('kador').feminine(),
      newNoun('kalon').feminine(),
      newNoun('karantez').feminine(),
      newNoun('koan').feminine(),
      newNoun('kontel').feminine(),
      newNoun('kudenn').feminine(),
      newNoun('paner').feminine(),
      newNoun('poan').feminine(), // le mal
      newNoun('pobl').feminine().people(),
      newNoun('poelladenn').feminine(),
      newNoun('taol').feminine(),
      newNoun('testenn').feminine(),
      newNoun('tresadenn').feminine(),
      newNoun('godell').feminine(),
      newNoun('gwastell').feminine(),
      newNoun('gwerenn').feminine(),
      newNoun('gwezenn').feminine(),
      newNoun('gwiskamant').feminine(),
      newNoun('bag').feminine(),
      newNoun('bazh').feminine(),
      newNoun('beaj').feminine(),
      newNoun('brec\'h').feminine(),
      newNoun('bro').feminine(),
      newNoun('douarenez').feminine().people(),
      newNoun('mamm').feminine().people(),
      newNoun('mell').feminine().people(),
      newNoun('micher').feminine(),
      newNoun('moger').feminine(),
      // an niverenn (numéro)
      // ar rann (un épisode)
    ],
  },
  {
    text: 'Masculine, singular:',
    words: [
      newNoun('karr'),
      newNoun('kig'),
      newNoun('penn'),
      newNoun('tad').people(),
      newNoun('ti'),
      newNoun('tour'),
      newNoun('traezh'),
      newNoun('glav'),
      newNoun('goulenn'),
      newNoun('bugel').people(),
      newNoun('bloaz'),
      newNoun('bleud'),
      newNoun('dorn'), // daouarn
      newNoun('douar'),
      newNoun('dour'),
      newNoun('maen'),
      newNoun('menez'),
      newNoun('mennozh'),
      newNoun('mor'),
      newNoun('muzul'),
      newNoun('aval'),
      newNoun('alc\'hwez'),
    ],
  },
  {
    text: 'Feminine, plural:',
    words: [
      newNoun('kadorioù').feminine().plural(),
      newNoun('bigi').feminine().plural(),
      newNoun('mammoù').feminine().plural().people(),
      newNoun('merc\'hed').feminine().plural().people(),
    ],
  },
  {
    text: 'Masculine, plural:',
    words: [
      newNoun('kelennerien').plural().people(),
      newNoun('kirri').plural(),
      newNoun('paotred').plural().people(),
      newNoun('tud').plural().people(),
      newNoun('tadoù').plural().people(),
      newNoun('galleger').plural().people(),
      newNoun('bugale').plural().people(),
      newNoun('deizioù').plural(),
      newNoun('mein').plural(),
      newNoun('mibien').plural().people(),
    ],
  },
];

export const sectionsForAdjective = [
  {
    words: [
      newAdjQual('kaer'),
      newAdjQual('kentañ'),
      newAdjQual('koant'),
      newAdjQual('kozh'),
      newAdjQual('paour'),
      newAdjQual('pinvidik'),
      newAdjQual('plijus'),
      newAdjQual('taer'),
      newAdjQual('glas'),
      newAdjQual('gwenn'),
      newAdjQual('gwirion'),
      newAdjQual('bihan'),
      newAdjQual('bras'),
      newAdjQual('brav'),
      newAdjQual('brezhonek'),
      newAdjQual('du'),
      newAdjQual('diwezhañ'),
      newAdjQual('mat'),
    ],
  },
];
